import script from "./registerPage.vue?vue&type=script&setup=true&lang=js"
export * from "./registerPage.vue?vue&type=script&setup=true&lang=js"

import "./registerPage.vue?vue&type=style&index=0&id=033dc078&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/DLJY-Web-Test/example/main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-033dc078"]])

export default __exports__